import React from "react";
import { CMSModel } from "./CMSModels";
import { CSelect } from "@coreui/react";
import { legacyPut } from "api/index";
import { useAuthContext } from "providers/AuthProvider/AuthProvider";
import { useToast } from "@chakra-ui/react";

interface ModelStatusProps {
  item: CMSModel;
  updateStatusEndpoint?: string;
  refetchRecords: () => void;
}

const ModelStatus: React.FC<ModelStatusProps> = ({
  item,
  refetchRecords,
  updateStatusEndpoint,
}) => {
  const toast = useToast();
  const { user } = useAuthContext();

  const updateItemStatus = async (itemId: any, status: string) => {
    if (!updateStatusEndpoint) {
      toast({
        title: "Status update endpoint not configured",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    const endPoint = updateStatusEndpoint.replace("{id}", `${itemId}`);

    const response: any = await legacyPut(
      endPoint,
      { status: status.toLowerCase() },
      undefined,
      user?.accessToken
    ).catch(() => {
      toast({
        title: "Couldn't update status of this record..",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    });
    if (response && response.id) {
      toast({
        title: `Successfully updated status of ${response.slug}`,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      refetchRecords();
    }
  };

  const handleSelectChange = (e: any) => {
    updateItemStatus(item.id, e.target.value);
  };

  return (
    <td>
      <CSelect
        className="form-select"
        aria-label="Default select example"
        onChange={(e) => {
          handleSelectChange(e);
        }}
        value={
          item.status
            ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
            : "Active"
        }
      >
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
        <option value="Expired">Expired</option>
      </CSelect>
    </td>
  );
};

export default ModelStatus;
